import { Breadcrumbs, Card, Grid, Typography } from "@material-ui/core/";
import { makeStyles } from "@material-ui/core/styles";
import MaterialTable from "material-table";

const useStyles = makeStyles((theme) => ({
	title: {
		margin: theme.spacing(1, 0),
	},
}));

const TableOnServices = (props) => {
	const classes = useStyles();
	const {
		BaseUrl,
		getDataTables,
		tableRef,
		pageSize,
		modalAdd,
		fetchAPI,
		modalEdit,
	} = props;

	const columns = [
		{ title: "Name", field: "nama" },
		{ title: "Description", field: "deskripsi" },
	];
	return (
		<Grid
			item
			direction="column-reverse"
			justifyContent="space-between"
			alignItems="stretch"
		>
			<Grid item>
				<Card className={classes.title}>
					<Breadcrumbs aria-label="breadcrumb" style={{ padding: "10px" }}>
						<Typography color="textPrimary" style={{ padding: "10px" }}>
							Dashboard
						</Typography>
						<Typography color="textPrimary" variant="h6">
							Services
						</Typography>
					</Breadcrumbs>
				</Card>

				<div style={{ marginTop: "20px" }}>
					<MaterialTable
						title="Services Register"
						tableRef={tableRef}
						columns={columns}
						data={getDataTables({ url: `${BaseUrl}` })}
						actions={[
							{
								icon: "add_box",
								tooltip: "Add",
								isFreeAction: true,
								onClick: () => modalAdd(),
							},
							() => ({
								icon: "delete",
								tooltip: "Delete",
								iconProps: { style: { fontSize: "20px", color: "red" } },
								onClick: (event, rowData) => {
									fetchAPI("delete", rowData);
								},
							}),
							{
								icon: "edit",
								tooltip: "Edit",
								iconProps: { style: { fontSize: "20px", color: "green" } },
								onClick: (evt, rowData) => modalEdit(rowData),
							},
						]}
						options={{
							actionsColumnIndex: -1,
							// selection: true,
							paginationType: "stepped",
							pageSize: pageSize,
							pageSizeOptions: [5, 10, 50, 100],
							headerStyle: {
								backgroundColor: "#67A3D5",
								color: "#FFF",
								whiteSpace: "nowrap",
							},
						}}
					/>
				</div>
			</Grid>
		</Grid>
	);
};

export default TableOnServices;
